import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Team } from "@/modules/team/entity/Team";
import { ref } from "vue";
import LineupFormation from "@/modules/team/components/LineupFormation.vue";
import { app } from "@/di";
import BeforeMatchMode from "@/modules/match/services/BeforeMatchMode";
import { Match } from "@/modules/match/entity";
import { Season } from "@/modules/season/entity";
import BeforeMatchLayout from "@/modules/match/layouts/BeforeMatchLayout.vue";
import PlayerList from "@/modules/team/components/PlayerList.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'FormationBeforeMatch',
  async setup(__props) {
    let __temp, __restore;
    const team = ref();
    const beforeMatchMode = ref(false);
    const nextMatch = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.createQueryBuilder('team').leftJoinAndSelect('team.players', 'player').innerJoinAndSelect('player.country', 'country').leftJoinAndSelect('player.suspensions', 'suspension').where('team.user = true').getOneOrFail();
      nextMatch.value = await Match.findNext(await Season.current(), team.value);
      beforeMatchMode.value = app.get(BeforeMatchMode).isEnabled();
    })), __temp = await __temp, __restore(), __temp);
    const onChangeFormation = async formation => {
      team.value.formation = formation;
      await team.value.save();
    };
    const notLinedupPlayers = computed(() => collect(team.value.players).where('lineup', null).sortBy('order'));
    return (_ctx, _cache) => {
      const _component_NDivider = _resolveComponent("NDivider");
      return _openBlock(), _createBlock(BeforeMatchLayout, null, {
        default: _withCtx(() => [_createVNode(LineupFormation, {
          team: team.value,
          "can-change": "",
          class: "-mx-2",
          "next-match": nextMatch.value,
          onUpdated: _unref(refresh),
          onReset: _unref(refresh),
          onChangeFormation: onChangeFormation
        }, null, 8, ["team", "next-match", "onUpdated", "onReset"]), _createVNode(_component_NDivider, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('bench')), 1)]),
          _: 1
        }), _createVNode(PlayerList, {
          players: _unref(notLinedupPlayers),
          "next-match": nextMatch.value,
          "show-talent": ""
        }, null, 8, ["players", "next-match"])]),
        _: 1
      });
    };
  }
});